var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDrawerOpenSource(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 -396) translate(0 212) translate(0 168) translate(20 16) translate(4 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5,
    height: 18.5,
    x: 0.75,
    y: 0.75,
    stroke: "#727272",
    strokeWidth: 1.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#727272",
    fillRule: "nonzero",
    d: "M4.316 10.309l2.137.718v1.2L3 10.82V9.781l3.453-1.406V9.57l-2.137.739zm3.082 2.867h-.933L8.406 7h.938l-1.946 6.176zm4.227-2.88L9.5 9.575V8.38l3.434 1.406v1.04L9.5 12.23v-1.195l2.125-.738z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrawerOpenSource);
export default __webpack_public_path__ + "static/media/iconDrawerOpenSource.2f69e320.svg";
export { ForwardRef as ReactComponent };